module.exports = __webpack_public_path__ + "static/media/semiconductors_5_mobile.029bf2f3.jpg";